import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import EditMobileLanguage from './EditMobileLanguage';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/jsonMessages';

export default async function action({ store, intl, params }) {

    const title = intl?.formatMessage(messages.mobileLanguage);
    const isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;
    const isMobileLanguageRestricted = store?.getState()?.siteSettings?.data?.isMobileLanguageRestricted;
    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/mobile-language', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><EditMobileLanguage title={title} languageCode={params?.code} appType={params?.appType} isMobileLanguageRestricted={isMobileLanguageRestricted} /></AdminLayout>,
    };
}
